module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Pick Up Instead',
        itemOutOfStock: 'This item is out of stock at your selected store.',
        pickupConfirmation: 'Do you want to pick up this item at the store below?',
        choosePickupStore: 'Please choose a pickup store.',
        chooseStoreWithPickup: 'Please choose a store that offers pickup.',
        checkAvailability: 'Check availability',
        chooseStore: 'Choose Store',
        confirm: 'Confirm',
        cancel: 'Cancel'
    };

    return resources[label];
};
